import DefaultValidation from '@/services/validations/DefaultValidation';
import { isNull } from "@/functions/Util";

export default class ApiWebHookAutenticacaoValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let msgs = [];
        let validated = true;

        if(model.metodo.id == 1){
            if (isNull(model.token)) {
                refs.tokenInputRef.focusedOut = true;
                validated = false;
                msgs.push('msg-erro-campo-token-obrigatorio');
            }
        }

        if(model.metodo.id == 2){
            if (isNull(model.usuario)) {
                refs.usuarioInputRef.focusedOut = true;
                validated = false;
                msgs.push('msg-erro-campo-usuario');
            }
            if (isNull(model.senha)) {
                refs.senhaInputRef.focusedOut = true;
                validated = false;
                msgs.push('msg-erro-campo-senha');
            }
            if (isNull(model.token)) {
                refs.tokenInputRef.focusedOut = true;
                validated = false;
                msgs.push('msg-erro-campo-token-obrigatorio');
            }
        }

        for(let i=0; i< model.headers.length; i++){
            let e = model.headers[i];

            if(isNull(e.chave) || isNull(e.valor)){
                validated = false;
                msgs.push('msg-erro-chave-valor');
                break;
            }
        }

        return {validated: validated, msgs: msgs};
    }
}